import { render, staticRenderFns } from "./CommissionChainModal.vue?vue&type=template&id=95eb1596&scoped=true"
import script from "./CommissionChainModal.vue?vue&type=script&lang=js"
export * from "./CommissionChainModal.vue?vue&type=script&lang=js"
import style0 from "./CommissionChainModal.vue?vue&type=style&index=0&id=95eb1596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95eb1596",
  null
  
)

export default component.exports